export const bezierCurve = 'cubic-bezier(.37, .99, .74, 1)'
